<ion-header no-border mode="md">
  <ion-toolbar color="primary" mode="md">
    <ion-title>
      {{ 'groups.importParticipants.header' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="light" (click)="cancel()" mode="ios">
        <ion-icon class="bp-close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="content">
  <div class="container-filters">
      <ion-item lines="none" >
          <ion-label position="floating" style="margin-top: 15px; margin-bottom:5px">
            {{ 'groups.importParticipants.label' | translate }}
          </ion-label>
          <ion-textarea
            [(ngModel)]="data"
            placeholder="123123123&#10;123123123&#10;123123123"
          ></ion-textarea>
      </ion-item>
      <ion-item lines="none" >
        <ion-label> {{ 'visibilityRules.substituteAll' | translate}} </ion-label>
        <ion-toggle [(ngModel)]="replace"></ion-toggle>
      </ion-item>
  </div>
  <div class="divider"></div>
  <div class="footer">
      <ion-button class="btn-save" mode="ios"
        [color]="'secondary'"
        (click)="cancel()">
        {{ 'generic.cancel' | translate }}
      </ion-button>
      <ion-button class="btn-save" mode="ios"
        [color]="'secondary'"
        (click)="send()">
        {{ 'goalsReview.sendGoalsBtn' | translate }}
      </ion-button>
  </div>
</ion-content>
